// src/app/router/ProtectedRoute.tsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@app/store/hooks';
import { Permission } from '@core/constants/permissions';
import { expandPermissions } from '@core/utils/permissionDependencies';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermissions?: Permission[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredPermissions,
}) => {
  const { isAuthenticated, permissions: assignedPermissions, roles } = useAppSelector((state) => state.auth);
  const permissions = expandPermissions(assignedPermissions);
  const { company, user } = useAppSelector((state) => state.user);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login_password" state={{ from: location }} replace />;
  }

  const isGlobalAdmin = roles.some((role) => role === 'admin');
  const hasCompanyAssociation = Boolean(
    company?.id ?? user?.company_id ?? localStorage.getItem('company_id'),
  );
  if (isGlobalAdmin && !hasCompanyAssociation && location.pathname !== '/change-password') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  if (requiredPermissions && requiredPermissions.length > 0) {
    const hasPermission = requiredPermissions.some((permission) =>
      permissions.includes(permission)
    );

    if (!hasPermission) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return <>{children}</>;
};

export default ProtectedRoute;

